import { render, staticRenderFns } from "./ImageBg.vue?vue&type=template&id=e94bc452&scoped=true&"
import script from "./ImageBg.vue?vue&type=script&lang=js&"
export * from "./ImageBg.vue?vue&type=script&lang=js&"
import style0 from "./ImageBg.vue?vue&type=style&index=0&id=e94bc452&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e94bc452",
  null
  
)

export default component.exports